<template>
  <div>
    <HeaderContent title="CheckOut Lists" />
    <ActionContent
      :cta="false"
      :filter-modal="false"
      ctaText="Add Check Out"
      @action="modal = !modal"
      @showFilter="modalFilter = !modalFilter"
      v-model:start-date="startDate"
      v-model:end-date="endDate"
      v-model:search="search"
      @search-query="handleSearch"
    />
    <CheckOutStatistics title="Check Out Statistics" :data="statistics" />
    <CheckOutForm :modal="modal" @update:modal="modal = $event" />
    <CheckOutFilter
      :modalFilter="modalFilter"
      @update:modalFilter="modalFilter = $event"
    />
    <ModalConfirm v-model="modalConfirm" handle-action="setCheckout">
      <template #text>Are you sure to checkout this guest ?</template>
    </ModalConfirm>
    <PaymentForm
      :modal="modalPayment"
      :uuid="reservationUuid"
      @update:modal="modalPayment = $event"
      @paid="getAll"
    />

    <CheckoutDetail
      title="Check-Out Info"
      :uuid="reservationUuid"
      :data="checkout"
      v-model="modalDetail"
      @update:modal="modalDetail = $event"
    >
    </CheckoutDetail>

    <CheckOutConfirm
      title="Check Out Confirmation"
      :uuid="reservationUuid"
      :data="checkout"
      :actionType="actionType"
      :modalConfirm="modalCheckOut"
      v-model="modalCheckOut"
      @confirmed="handleAction"
    >
      <template #body>
        <div class="guest-info text-start">
          <!-- <div>
            informasi tamu
            <div class="px-3 border-bottom">
              <p class="text-secondary fw-semibold mb-2">Guest Information</p>
              <ul class="guest">
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold label">ID/Pasport</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    checkout?.reservation?.guest?.identity_number ?? "-"
                  }}</span>
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold label">Name</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    checkout.reservation?.guest?.fullname ?? "-"
                  }}</span>
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold label">Contact</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold"
                    >0{{ checkout.reservation?.guest?.phone ?? "-" }}</span
                  >
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold label">Check In</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    dateFormatter(checkout?.check_in_date) ?? "-"
                  }}</span>
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold label">Check Out</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    dateFormatter(checkout?.check_out_date) ?? "-"
                  }}</span>
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold label">Stay Duration</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    countDays(checkout?.check_in_date, checkout?.check_out_date)
                  }}</span>
                </li>
              </ul>
            </div>

            Detail Tagihan
            <div class="p-3 border-bottom">
              <p class="text-secondary fw-semibold mb-2">Billing Details</p>
              <ul class="billing">
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold">Room Type</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    checkout?.reservation?.room?.room_category?.name ?? "-"
                  }}</span>
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold">Room Number</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    checkout?.reservation?.room?.code ?? "-"
                  }}</span>
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold">Room Rate</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    formatIDR(
                      checkout?.reservation?.room?.room_category
                        ?.low_season_price ?? 0
                    )
                  }}</span>
                </li>
                <li class="mb-1" style="list-style: none">
                  <div class="d-flex gap-2 align-items-start">
                    <span class="fw-semibold">Extra Charge</span>
                    <span class="fw-semibold label">:</span>
                    <div class="extra-charges">
                      <div
                        v-if="checkout?.reservation?.extracharge?.length === 0"
                        class="fw-semibold"
                      >
                        -
                      </div>
                      <div
                        v-for="(item, index) in checkout?.reservation
                          ?.extracharge ?? []"
                        :key="index"
                        class="extra-charge-item fw-semibold"
                      >
                        {{ item?.extra_charge?.name }} (Qty:
                        {{ item?.quantity }},
                        {{ formatIDR(item?.extra_charge?.price ?? 0) }})
                      </div>
                    </div>
                  </div>
                </li>
                <li class="mb-1" style="list-style: none">
                  <div class="d-flex gap-2 align-items-start">
                    <span class="fw-semibold">Payment</span>
                    <span class="fw-semibold label">:</span>
                    <div class="payments">
                      <div
                        v-if="checkout?.reservation?.payment?.length === 0"
                        class="fw-semibold"
                      >
                        -
                      </div>
                      <div
                        v-for="(item, index) in checkout?.reservation
                          ?.payment ?? []"
                        :key="index"
                        class="payment-item fw-semibold"
                      >
                        {{ item?.payment_type }} (Date:
                        {{ item?.payment_date }},
                        {{ formatIDR(item?.amount ?? 0) }})
                      </div>
                    </div>
                  </div>
                </li>

                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold">Pending Bill</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    formatIDR(checkout?.reservation?.outstanding_balance ?? 0)
                  }}</span>
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold">Total</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    formatIDR(checkout?.reservation?.total_paid ?? 0)
                  }}</span>
                </li>
                <li class="mb-1 d-flex gap-2">
                  <span class="fw-semibold">Status</span>
                  <span class="fw-semibold label">:</span>
                  <span class="fw-semibold">{{
                    checkout?.reservation?.payment_status ?? "-"
                  }}</span>
                </li>
                
              </ul>
            </div>
          </div> -->

          <!--  Kop & logo (print)  -->
          <div class="print-only text-center mb-4">
            <table class="w-full text-left border-collapse">
              <tbody>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">
                    <!-- <img src="../../../public/img/hotel-deliriver.png" alt="Deli River Logo" style="width: 100px; height: auto;" /> -->
                    <img
                      src="logo"
                      ref="printLogo"
                      alt="Deli River Logo"
                      style="width: 100px; height: auto"
                    />
                  </td>
                  <td class="text-left pr-2">
                    <h3 class="mt-2 mb-0">Deli River Hotel</h3>
                    <p class="mb-0">
                      Jl. Raya Namorambe No. 129, Medan, Indonesia
                    </p>
                    <p class="mb-0">
                      Phone: +62-61-7032967 | email: contact@hotel-deliriver.com
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
          </div>

          <h4 class="print-only text-align-center">CheckOut Receipt</h4>

          <div class="px-3 border-bottom">
            <p class="text-secondary fw-semibold mb-2">Guest Information</p>
            <table class="w-full text-left border-collapse">
              <tbody>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">ID/Passport</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ checkout?.reservation?.guest?.identity_number ?? "-" }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Name</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ checkout?.reservation?.guest?.fullname ?? "-" }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Contact</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    0{{ checkout?.reservation?.guest?.phone ?? "-" }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Check In</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ dateFormatter(checkout?.check_in_date) }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Check Out</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ dateFormatter(checkout?.check_out_date) }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Duration</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{
                      countDays(
                        checkout?.check_in_date,
                        checkout?.check_out_date
                      )
                    }}
                    night
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div class="px-3">
            <p class="text-secondary fw-semibold mb-2">Billing Detail</p>
            <table class="w-full text-left border-collapse">
              <tbody>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Room Type</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{
                      checkout?.reservation?.room?.room_category?.name ?? "-"
                    }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Room Number</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ checkout?.reservation?.room?.code ?? "-" }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Room Rate</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{
                      formatIDR(
                        checkout?.reservation?.room?.room_category
                          ?.low_season_price ?? 0
                      )
                    }}
                  </td>
                </tr>

                <!-- Extra Charge -->
                <tr class="border-b border-transparent align-top">
                  <td class="text-left pr-2">Extra Charge</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    <div v-if="!checkout?.reservation?.extracharge?.length">
                      -
                    </div>
                    <div
                      v-else
                      v-for="(item, index) in checkout?.reservation
                        ?.extracharge"
                      :key="index"
                    >
                      {{ item.extra_charge?.name }} (Qty: {{ item.quantity }},
                      {{ formatIDR(item.extra_charge?.price ?? 0) }})
                    </div>
                  </td>
                </tr>

                <!-- Payments -->
                <tr class="border-b border-transparent align-top">
                  <td class="text-left pr-2">Payment</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    <div v-if="!checkout?.reservation?.payment?.length">-</div>
                    <div
                      v-else
                      v-for="(item, index) in checkout?.reservation?.payment"
                      :key="index"
                    >
                      <!-- {{ item.payment_type }} 
                            (Date: {{ item.payment_date }}, {{ formatIDR(item.amount ?? 0) }}) -->

                      {{ item.payment_type }}
                      ({{ formatIDR(item.amount ?? 0) }} at
                      {{ getFormattedDate(item.payment_date) }})
                    </div>
                  </td>
                </tr>

                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Pending Bill</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{
                      formatIDR(checkout?.reservation?.outstanding_balance ?? 0)
                    }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Total</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ formatIDR(checkout?.reservation?.total_paid ?? 0) }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left pr-2">Status</td>
                  <td class="text-left pr-2">:</td>
                  <td class="text-left fw-semibold">
                    {{ checkout?.reservation?.payment_status ?? "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </CheckOutConfirm>

    <CheckOutDataTable
      :data="checkouts"
      :header="headers"
      :currentPage="currentPage"
      :custom-actions="customActions"
    />

    <!-- <DataPriview
      id="guestInfoModal"
      :selectedGuest="selectedGuest"
      :reservationDetails="reservationDetails"
      :extraCharges="extraCharges"
    /> -->

    <CheckOutFilter
      :modalFilter="modalFilter"
      @update:modalFilter="modalFilter = $event"
    />

    <ToastResponse
      v-model="toastResponse.toast"
      :text="toastResponse.text"
      :success="toastResponse.success"
    />
  </div>
</template>

<script>
import { ref, inject, onMounted, watch, nextTick } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import CheckOutForm from "./CheckoutForm.vue";
import CheckOutFilter from "./CheckoutFilter.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import CheckOutConfirm from "@/components/ModalDialog.vue";
import CheckOutStatistics from "@/components/StatisticData.vue";
import CheckOutDataTable from "@/components/DataTable.vue";
import iconWill from "../../../public/icons/visit.svg";
import iconPremature from "../../../public/icons/master-plan.svg";
import iconLate from "../../../public/icons/overview.svg";
import iconCheckOut from "../../../public/icons/door-open.svg";
// import DataPriview from "@/components/DataPriview.vue";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
import PaymentForm from "@/components/Payment/PaymentForm.vue";
import CheckoutDetail from "./CheckoutDetail.vue";
import ToastResponse from "@/components/ToastResponse.vue";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";
import logo from "../../../public/img/hotel-deliriver.png";

export default {
  components: {
    HeaderContent,
    ActionContent,
    CheckOutForm,
    CheckOutConfirm,
    CheckOutFilter,
    CheckOutStatistics,
    CheckOutDataTable,
    ModalConfirm,
    // DataPriview,
    PaymentForm,
    CheckoutDetail,
    ToastResponse,
  },
  setup() {
    const repositories = inject("repositories");
    const checkinRepository = repositories ? repositories.checkin : null;
    const modal = ref(false);
    const modalPayment = ref(false);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const modalCheckOut = ref(false);
    const modalDetail = ref(false);
    const modalUuid = ref("");
    const selectedGuest = ref(null);
    const reservationDetails = ref(null);
    const extraCharges = ref([]);
    const isLoading = ref(false);
    const currentPage = ref(1);

    const reservationUuid = ref(null);
    const actionType = ref("checkout");
    const checkouts = ref([]);
    const checkout = ref({});

    const statistics = ref([]);

    const data = ref([]);
    const printLogo = ref(null);

    const toastResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const headers = ref([
      {
        key: "room_category",
        label: "Room Type",
        sortable: true,
      },
      {
        key: "reservation.room.code",
        label: "Room Number",
        sortable: true,
      },
      {
        key: "reservation.guest.fullname",
        label: "Guest Name",
        sortable: true,
      },
      {
        key: "status_reservation",
        label: "Status",
        sortable: true,
      },
      {
        key: "check_in_date",
        label: "Checkin",
        sortable: true,
        formatter: (value) => getFormattedDate(value)
      },
      {
        key: "check_out_date",
        label: "Checkout",
        sortable: true,
        formatter: (value) => getFormattedDate(value)
      },
      {
        key: "day_left",
        label: "Day Left",
        sortable: true,
      },
      {
        key: "reservation.outstanding_balance",
        label: "Bill",
        sortable: true,
      },
      {
        key: "action",
        label: "Action",
      },
    ]);

    const customActions = ref([
      {
        label: "Bill Info",
        variant: "success",
        icon: "fas fa-file-alt",
        action: async (item) => {
          console.log(item);

          checkout.value = item;
          showDetailModal(item);
        },
      },
      {
        label: "Payment",
        variant: "primary",
        icon: "fas fa-money-bill-wave-alt",
        disabled: (item) =>
          item.reservation.is_paid ||
          item.reservation.payment_status === "Full Payment",
        action: (item) => {
          reservationUuid.value = item.reservation_uuid;
          modalPayment.value = true;
        },
      },
      {
        label: "Checkout",
        variant: "danger",
        icon: "fas fa-calendar-times",
        disabled: (item) =>
          !item.reservation.is_paid ||
          item.reservation.payment_status === "DP" ||
          item.reservation.status === "Check Out" ||
          item.check_out_date !== formatDate(new Date()),
        action: (item) => {
          checkout.value = item;
          showConfirmModal(item);
        },
      },
    ]);

    const date = new Date();
    const getStartDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-01`;
    const getCurrentDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    const startDate = ref(getStartDate);
    const endDate = ref(getCurrentDate);
    const search = ref("");
    const filterStatus = ref({
      status: null,
    });

    function formatDate(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}`;
    }

    const getAll = async (
      start = null,
      end = null,
      status = null,
      searchQuery = ""
    ) => {
      const params = {};
      if (start) params.start = start;
      if (end) params.end = end;
      if (status && status !== "All") params.status = status;
      if (searchQuery) params.search = searchQuery;

      const res = await checkinRepository.getListCheckout(params);

      checkouts.value = res.data.data;
      const checkoutStatistics = res.data.statistics;

      statistics.value = [
        {
          label: "Total",
          key: "Will Check-Out",
          value: checkoutStatistics?.will_checkout,
          color: "warning",
          icon: iconWill,
        },
        {
          label: "Total",
          key: "Early Check-Out",
          value: checkoutStatistics?.early_checkout,
          color: "warning",
          icon: iconPremature,
        },
        {
          label: "Total",
          key: "Late Check-Out",
          value: checkoutStatistics?.late_checkout,
          color: "danger",
          icon: iconLate,
        },
        {
          label: "Total",
          key: "Check-Out",
          value: checkoutStatistics.checkout,
          color: "warning",
          icon: iconCheckOut,
        },
      ];
    };

    const showConfirmModal = (data) => {
      modalCheckOut.value = true;
      reservationUuid.value = data.reservation.uuid;
    };

    const showDetailModal = (data) => {
      modalDetail.value = true;
      reservationUuid.value = data.reservation.uuid;
      console.log("data reservati", reservationUuid.value);
    };

    const handleAction = (actionType) => {
      if (actionType.type === "checkout") {
        setCheckout();
      }
    };

    const handleFilter = (filterData) => {
      filterStatus.value = filterData;
      getAll(startDate.value, endDate.value);
    };

    const handleSearch = (query) => {
      search.value = query;
      getAll(startDate.value, endDate.value, filterStatus.value.status, query);
    };

    watch([startDate, endDate, filterStatus], () => {
      getAll(
        startDate.value,
        endDate.value,
        filterStatus.value.status,
        search.value
      );
    });

    const setCheckout = async () => {
      try {
        await checkinRepository
          .checkOut(reservationUuid.value, checkout.value)
          .then(() => {
            getAll();
            handlePrint();
            modalCheckOut.value = false;

            toastResponse.value = {
              toast: true,
              success: true,
              text:
                checkout.value.response?.message ||
                "Guest checked out successfully",
            };
          });
      } catch (e) {
        toastResponse.value = {
          toast: true,
          success: false,
          text: e.response?.data?.error || "Something went wrong!",
        };
        console.log(e);
      }
    };

    function handlePrint() {
      nextTick(() => {
        const printContents = document.getElementById("printArea").innerHTML;
        const printWindow = window.open("", "", "height=600,width=800");
        const getToday = new Date().toISOString().slice(0, 10);
        const filename = `Resi-DeliRiverHotel-${getToday}`;

        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${filename}</title>
            <style>
              body{font-family:sans-serif;padding:20px;}h2{margin-bottom:10px;}p{margin:0 0 5px;}
            </style>
          </head>
          <body>
            ${printContents}
          </body>
        </html>`);
        printWindow.document.close();
        // printWindow.focus()
        // printWindow.print()
        // // setTimeout(() => {
        // //     printWindow.print();
        // //   }, 300); // memberi waktu untuk render logo
        // printWindow.close()

        printWindow.onload = () => {
          const logo = printWindow.document.querySelector("img");
          if (logo && !logo.complete) {
            logo.onload = () => {
              printWindow.focus();
              printWindow.print();
              printWindow.close();
            };
          } else {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }
        };
      });
    }

    onMounted(() => {
      getAll();
    });

    return {
      data,
      headers,
      modal,
      modalPayment,
      checkout,
      checkouts,
      modalConfirm,
      modalCheckOut,
      modalFilter,
      actionType,
      handleAction,
      handleFilter,
      handleSearch,
      startDate,
      endDate,
      search,
      filterStatus,
      formatIDR,
      dateFormatter,
      countDays,
      getFormattedDate,
      customActions,
      statistics,
      checkinRepository,
      getAll,
      setCheckout,
      modalUuid,
      reservationUuid,
      selectedGuest,
      reservationDetails,
      extraCharges,
      isLoading,
      currentPage,
      modalDetail,
      toastResponse,
      logo,
      printLogo,
    };
  },
};
</script>
<style scoped>
.bg-primary {
  background-color: #0d6efd !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.text-start {
  text-align: left !important;
}

.fs-4 {
  font-size: 1.5rem;
}

ul {
  padding-left: 0;
}

li span:first-child {
  min-width: 100px;
  flex-shrink: 0;
}

.billing li span:first-child {
  min-width: 160px;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:nth-child(2) {
  width: 10px;
  text-align: left;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:last-child {
  flex: 1;
  font-weight: bold;
  word-wrap: break-word;
}

/* Style untuk extra charges */
.extra-charges {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.extra-charge-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #007bff;
}

.payments {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.payment-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #00f974;
}

/* style untuk print */
@media print {
  body * {
    visibility: hidden;
  }
  #printArea,
  #printArea * {
    visibility: visible;
  }
  #printArea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  button {
    display: none !important;
  }

  .navbar,
  .footer,
  .btn {
    display: none;
  }
  .print-only {
    display: block !important;
  }
  .screen-only {
    display: none !important;
  }
}

/* Elemen hanya layar vs hanya print */
.print-only {
  display: none;
}
.screen-only {
  display: block;
}
</style>
